import { useQuery } from '@tanstack/react-query';
import { fetchBroadcastRecipients } from '../../../../services/broadcastService';
import { IBroadcastRecipient } from '../../types';

export const broadcastRecipientsQueryKey = 'broadcastRecipients';

export const useFetchBroadcastRecipients = () => {
  const { data, isFetching } = useQuery<IBroadcastRecipient[]>(
    [broadcastRecipientsQueryKey],
    () => fetchBroadcastRecipients()
  );

  return {
    items: data ?? [],
    isLoading: isFetching ?? true,
  };
};
